import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useDialog from "../../../hooks/useDialog";
import { defaultDatePickerStrings } from "@fluentui/react-datepicker-compat";
import { I18N_NS_DOCUMENTS, translationCommonOptions } from "../constants";
import moment from "moment";
import { toast } from "sonner";
import { downloadFile } from "../../../api/downloadFile";

const useLogicDialogExportHoursWorked = () => {
    // * STATES & CONTEXTS
    // * STATES & CONTEXTS
    // * STATES & CONTEXTS
    const { t } = useTranslation(I18N_NS_DOCUMENTS);
    const [status, setStatus] = useState(1);
    const [selectedEmployeesDepartments, setSelectedEmployeesDepartments] =
        useState([]);
    const [monthYear, setMonthYear] = useState({
        startDate: null,
        endDate: null,
    });
    const [downloadingExcel, setDownloadingExcel] = useState(false);
    const [open, _, openDialog, closeDialog] = useDialog();

    // * ASSIGN
    // * ASSIGN
    // * ASSIGN
    const isValidForm = !!monthYear.startDate && !!monthYear.endDate;
    const localizedStrings = useMemo(
        () => ({
            ...defaultDatePickerStrings,
            days: t("temporal.days", translationCommonOptions),
            shortDays: t("temporal.shortDays", translationCommonOptions),
            months: t("temporal.months", translationCommonOptions),
            shortMonths: t("temporal.shortMonths", translationCommonOptions),
            goToToday: t("temporal.goToToday", translationCommonOptions),
        }),
        [t]
    );
    const statusItems = useMemo(
        () => [
            {
                id: 0,
                header: t("society.timesheet.dialog.form.status.all_expenses"),
            },
            { id: 1, header: t("society.timesheet.dialog.form.status.to_pay") },
        ],
        [t]
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const onChangeStatus = (_, i) => {
        setStatus(i.value?.id ?? 1);
        return;
    };
    const beforeCloseDialog = () => {
        resetStates();
        closeDialog();
        return;
    };
    const resetStates = () => {
        setMonthYear({
            startDate: null,
            endDate: null,
        });
        setSelectedEmployeesDepartments([]);
        setStatus(1);
        return;
    };
    const onFormatDate = (date) => {
        if (date) {
            return `${
                localizedStrings.months[date.getMonth()]
            } ${date.getFullYear()}`;
        }
        return "";
    };
    const onSelectDate = (date) => {
        if (date) {
            const startDate = moment(date).startOf("month");
            const endDate = moment(date).endOf("month");
            setMonthYear({
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: endDate.format("YYYY-MM-DD"),
            });
        }
    };
    const onChangeUsersDepartments = (e, i) => {
        setSelectedEmployeesDepartments(i.value);
    };
    const downloadExcel = async () => {
        if (!monthYear.startDate || !monthYear.endDate) {
            toast.error("Veuillez sélectionner un mois et une année.", {
                position: "bottom-right",
            });
            return;
        }
        setDownloadingExcel(true);
        const url = `/time_reporting/hr/export-ocirt?tp=${status}&start_date=${monthYear.startDate}&end_date=${monthYear.endDate}`;
        const urlParamsUd = selectedEmployeesDepartments
            .map((d) => `&ud=${d.key}`)
            .join("");
        const result = await downloadFile({
            url: `${url}${urlParamsUd}`,
        });

        if (!result.success) {
            toast.error(
                result.message ||
                    "Une erreur est survenue lors du téléchargement.",
                {
                    position: "bottom-right",
                }
            );
        }
        beforeCloseDialog();
        setDownloadingExcel(false);
        toast.success(
            `Le fichier "${result.filename}" a été téléchargé avec succès.`,
            {
                position: "bottom-right",
            }
        );
    };

    return {
        translations: {
            t,
            localizedStrings,
        },
        dialog: {
            open,
            openDialog,
        },
        functions: {
            onFormatDate,
            onSelectDate,
            onChangeUsersDepartments,
            downloadExcel,
            beforeCloseDialog,
            onChangeStatus,
        },
        form: {
            isValid: isValidForm,
            isDownloading: downloadingExcel,
            value: monthYear.startDate ? new Date(monthYear.startDate) : null,
            status: {
                list: statusItems,
                defaultItem: statusItems.at(1),
            },
        },
    };
};

export default useLogicDialogExportHoursWorked;
